export default __webpack_public_path__ + "static/media/image.waste-to-wages.3f530cd4.png";